import React from 'react'

export default function ExampleBtn({width, height, bg_color, color, text, action}) {
  return (
    <div className="exampleBtn" style={{width:`${width}`,height:`${height}`,backgroundColor:`${bg_color}`, color:`${color}`}} onClick={action}>{text}</div>
  )
}
